import { parse } from 'node-html-parser';

export function getImageFromContent(content) {
  const root = parse(content);
  const img = root.querySelector('img').attributes.src;
  //TODO: add error handling, empty src, multiple images
  return img;
}
